import PropTypes from 'prop-types';
import Image from '../Image';

const FullPicture = (props) => {
    return <div className="preview-full">
            <div className="switch-full">
                <button onClick={props.beforeElem}>Précédente</button>
                <button onClick={props.nextElem}>Suivante</button>
            </div>
            <a href={props.urlDownload} target="_urlDownload" title="Télécharger"><Image url={props.url} className="img-preview-full" /></a>
            <label>{props.label}</label>
        </div>;
}

FullPicture.propTypes = {
    label: PropTypes.string.isRequired,
    url: PropTypes.string
}

export default FullPicture;